// extracted by mini-css-extract-plugin
export default {"rounded_image":"style_rounded_image__GBXpX","px75":"style_px75__vyQjN"};